{
  "dss": {
    "button": {
      "back": "ย้อนกลับ",
      "cancel": "ยกเลิก",
      "close": "ปิด",
      "confirmDelete": "ใช่, ลบ",
      "continue": "ดำเนินการต่อ",
      "logout": "ออกจากระบบ",
      "passwordReset": "รีเซ็ตรหัสผ่าน",
      "save": "บันทึก",
      "verify": "ยืนยัน"
    },
    "error": {
      "403": "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
      "404": "หน้านี้ไม่มีอยู่",
      "generic": "เกิดข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง",
      "throttling": "พยายามหลายครั้งเกินไป การดำเนินการนี้ถูกบล็อกชั่วคราว",
      "title": "ข้อผิดพลาด",
      "title403": "ปฏิเสธการเข้าถึง",
      "title404": "ไม่พบ"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "นโยบายความเป็นส่วนตัว",
      "terms": "ข้อกำหนดและเงื่อนไข"
    },
    "label": {
      "CRMAccountNumber": "หมายเลขบัญชี CRM",
      "contact": "ติดต่อ",
      "email": "อีเมล",
      "faq": "คำถามที่พบบ่อย",
      "female": "น.ส./นาง",
      "firstname": "ชื่อ",
      "help": "วิธีใช้",
      "language": "ภาษา",
      "lastname": "นามสกุล",
      "male": "นาย",
      "needHelp": "ต้องการความช่วยเหลือหรือไม่?",
      "newPassword": "รหัสผ่านใหม่",
      "newPassword2": "ยืนยันรหัสผ่านใหม่",
      "oldPassword": "รหัสผ่านปัจจุบัน",
      "organization": "องค์กร",
      "password": "รหัสผ่าน",
      "required": "จำเป็น",
      "salutation": "คำนำหน้าชื่อ",
      "select": "โปรดเลือก"
    },
    "lang": {
      "de": "เยอรมัน"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "ยืนยันการลงทะเบียน",
        "wait": "โปรดรอจนกว่าจะเสร็จสิ้นการยืนยันบัญชี"
      },
      "otp": {
        "btnResend": "ส่งอีเมลรหัสยืนยันอีกครั้ง",
        "msg": {
          "invalidOTP": "รหัสผ่านแบบใช้ครั้งเดียวที่ป้อนไม่ถูกต้อง",
          "resendFail": "ส่งรหัสอีกครั้งไม่สำเร็จ โปรดลองใหม่ภายหลัง"
        },
        "spamDetail": "ตรวจสอบกล่องจดหมายเข้าและโฟลเดอร์สแปมสำหรับอีเมลจาก STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "ไม่ได้รับอีเมลหรือไม่?",
        "subtitle": "เพื่อดำเนินการต่อ คุณต้องยืนยันที่อยู่อีเมลของคุณ",
        "title": "ยืนยันบัญชีผู้ใช้ของคุณ",
        "txtVerifyMail": "โปรดป้อนรหัสยืนยันใหม่ที่เราส่งไปยังที่อยู่อีเมล {email} ของคุณ"
      },
      "personal": {
        "msg": {
          "noChange": "ไม่มีสิ่งใดให้ปรับปรุง",
          "updateError": "ไม่สามารถอัปเดตข้อมูลส่วนบุคคลได้",
          "updated": "อัปเดตข้อมูลส่วนบุคคลเรียบร้อยแล้ว",
          "userLoadErr": "เกิดข้อผิดพลาดระหว่างโหลดข้อมูลผู้ใช้ โปรดลองอีกครั้งในภายหลัง"
        },
        "secOrganization": "องค์กร",
        "secPersonal": "ส่วนบุคคล",
        "secSettings": "การตั้งค่าที่ต้องการ",
        "title": "ข้อมูลส่วนบุคคล"
      },
      "postPwSet": {
        "info": "ขณะนี้คุณสามารถใช้รหัสผ่านใหม่ของคุณได้",
        "link_name": "ไปยัง Self-Service",
        "link_url": "/user/ui/",
        "title": "รหัสผ่านของคุณถูกเปลี่ยนแล้ว"
      },
      "resetPW": {
        "title": "รีเซ็ตรหัสผ่านของคุณ"
      },
      "security": {
        "2fa": {
          "availableMethods": "วิธีการ 2FA ที่มีอยู่:",
          "info": "การยืนยันตัวตนแบบสองปัจจัย (2FA) เป็นคุณสมบัติด้านความปลอดภัยที่เพิ่มชั้นการป้องกันเพิ่มเติมให้กับบัญชีของคุณ โดยต้องใช้สองวิธีในการลงชื่อเข้าใช้แทนที่จะเป็นเพียงชื่อผู้ใช้และรหัสผ่าน",
          "method": {
            "email": "อีเมล",
            "emailDesc": "รับรหัสใช้ครั้งเดียวผ่านอีเมลเพื่อทำคำขอการยืนยันตัวตนให้เสร็จสมบูรณ์",
            "oath": {
              "add": {
                "button": "ลงทะเบียนแอป Authenticator"
              }
            }
          }
        },
        "authenticator": "แอป Authenticator",
        "infoFederatedAccount": "บัญชีนี้ได้รับการจัดการโดยผู้ให้บริการข้อมูลประจำตัวขององค์กรของคุณ ดังนั้นจึงไม่สามารถเปลี่ยนรหัสผ่านได้ที่นี่ หากต้องการเปลี่ยนรหัสผ่าน โปรดเข้าสู่ระบบผ่านหน้าเข้าสู่ระบบขององค์กรของคุณหรือติดต่อผู้ดูแลระบบไอทีของคุณ",
        "lastUse": "ใช้งานครั้งล่าสุดเมื่อ {0}",
        "msg": {
          "invalidPassword": "รหัสผ่านปัจจุบันไม่ถูกต้อง",
          "passwordAlreadyUsed": "ไม่สามารถใช้รหัสผ่าน 5 รายการล่าสุดซ้ำได้",
          "pwUpdateError": "เกิดข้อผิดพลาดขณะพยายามเปลี่ยนรหัสผ่าน",
          "pwUpdated": "เปลี่ยนรหัสผ่านแล้ว"
        },
        "noDevice": "ไม่ได้กำหนดค่า",
        "oathAdd": {
          "appInfo": "เพื่อให้ง่ายต่อการเข้าสู่ระบบ STIHL คุณสามารถใช้แอป Authenticator เช่น {0}, {1}, {2} เป็นต้น เพื่อสร้างรหัสผ่านแบบใช้ครั้งเดียวซึ่งใช้เป็นปัจจัยที่สองระหว่างขั้นตอนการเข้าสู่ระบบ<br/>หากคุณทำอุปกรณ์พกพาหายหรือจำไม่ได้ คุณยังสามารถใช้รหัส 2FA ที่ส่งทางอีเมลได้ทุกเมื่อ<br/><br/>โปรดทำตามคำแนะนำด้านล่างเพื่อกำหนดค่าอุปกรณ์ยืนยันตัวตนของคุณ",
          "badCode": "โค้ดไม่ถูกต้อง โปรดลองอีกครั้ง",
          "error": "เกิดข้อผิดพลาดขณะพยายามลงทะเบียนอุปกรณ์ยืนยันตัวตน",
          "headScan": "1. สแกนโค้ด QR ด้วยแอป Authenticator ของคุณ",
          "headVerify": "2. ยืนยันโค้ด",
          "infoKey": "คีย์การตั้งค่า",
          "infoKeyTitle": "ความลับแบบสองปัจจัยของคุณ",
          "infoScanBottom": "สแกนไม่ได้? คุณสามารถใช้ {0} เพื่อกำหนดค่าแอป Authenticator ของคุณด้วยตนเอง",
          "infoVerify": "ป้อนโค้ดที่สร้างโดยแอป Authenticator ของคุณ",
          "success": "อุปกรณ์ยืนยันตัวตนของคุณได้รับการลงทะเบียนแล้ว ขณะนี้คุณสามารถใช้เพื่อเข้าลงชื่อเข้าใช้ได้",
          "title": "ลงทะเบียนอุปกรณ์ยืนยันตัวตนแบบสองปัจจัยของคุณ"
        },
        "oathDelete": {
          "error": "เกิดข้อผิดพลาดขณะพยายามลบอุปกรณ์ยืนยันตัวตน",
          "success": "ลบอุปกรณ์ยืนยันตัวตนเรียบร้อยแล้ว"
        },
        "passkeys": {
          "about": {
            "info1": "Passkey คือคู่ของกุญแจเข้ารหัส (กุญแจสาธารณะและกุญแจส่วนตัว) ที่จัดเก็บโดยอุปกรณ์ยืนยันตัวตนภายใต้การควบคุมของคุณ อุปกรณ์ยืนยันสามารถพิสูจน์ได้ว่าผู้ใช้มีตัวตนอยู่และได้รับอนุญาตให้ใช้ passkey การอนุญาตพิสูจน์ด้วย PIN โค้ด ไบโอเมตริก หรือรหัสผ่านอุปกรณ์ ขึ้นอยู่กับความสามารถและการตั้งค่าของอุปกรณ์ยืนยัน อุปกรณ์ยืนยันมีได้หลายรูปแบบ เช่น iPhone หรืออุปกรณ์ Android, Windows Hello, กุญแจความปลอดภัยฮาร์ดแวร์ FIDO2 หรือผู้จัดการรหัสผ่าน",
            "info2": "เมื่อคุณลงชื่อเข้าใช้ STIHL ด้วย passkey อุปกรณ์ยืนยันของคุณจะใช้การเข้ารหัสกุญแจสาธารณะเพื่อพิสูจน์ตัวตนของคุณกับ STIHL โดยไม่ต้องส่ง passkey เอง Passkey จะผูกกับโดเมนของเว็บไซต์ เช่น stihl-sso.com และต้องใช้การเชื่อมต่อที่ปลอดภัย ซึ่งหมายความว่าเบราว์เซอร์จะปฏิเสธการยืนยันตัวตนบนเว็บไซต์ฟิชชิ่งที่คล้ายกัน คุณสมบัติเหล่านี้ทำให้ passkey ทนทานต่อฟิชชิ่งอย่างมากและโจมตีได้ยากกว่า SMS หรือ TOTP 2FA มาก",
            "info3": "บริการ passkey ที่รองรับระบบคลาวด์ช่วยให้สามารถซิงค์กุญแจระหว่างอุปกรณ์ต่าง ๆ (เช่น อุปกรณ์ Apple, Android หรือผู้จัดการรหัสผ่าน) เพื่อให้ใช้งานได้ในหลายที่และสูญหายได้ยากขึ้น เมื่อคุณตั้งค่า passkey ที่ซิงค์บนอุปกรณ์หนึ่งแล้ว passkey นั้นจะพร้อมใช้งานบนอุปกรณ์หลายเครื่องที่ใช้บริการเดียวกัน ตัวอย่างเช่น หากคุณลงทะเบียน passkey กับบัญชี iCloud โดยใช้ Touch ID บน MacBook คุณก็สามารถใช้ passkey นั้นด้วยใบหน้า ลายนิ้วมือ PIN หรือรหัสผ่านอุปกรณ์ได้สลับกันบนอุปกรณ์หลายเครื่องที่เชื่อมโยงกับบัญชี iCloud เดียวกัน",
            "title": "เกี่ยวกับ Passkeys"
          },
          "add": {
            "button": "เพิ่ม Passkey ใหม่",
            "error": "เกิดข้อผิดพลาดขณะเพิ่ม passkey ใหม่",
            "success": "เพิ่ม passkey ใหม่แล้ว"
          },
          "delete": {
            "button": "ลบ Passkey",
            "error": "เกิดข้อผิดพลาดขณะลบ passkey นี้",
            "success": "ลบ Passkey แล้ว"
          },
          "edit": {
            "error": "เกิดข้อผิดพลาดขณะบันทึกชื่อ passkey",
            "name": "ชื่อ Passkey",
            "success": "อัปเดตชื่อ passkey แล้ว",
            "title": "ตั้งชื่อ Passkey ของคุณเพื่อแยกความแตกต่างจาก passkey อื่น ๆ"
          },
          "info": "Passkey เป็นทางเลือกที่เรียบง่ายและปลอดภัยแทนรหัสผ่าน โดยยืนยันตัวตนของคุณด้วยการสัมผัส การจดจำใบหน้า รหัสผ่านอุปกรณ์ หรือ PIN",
          "none": "ยังไม่ได้กำหนดค่า Passkey",
          "reallyDelete": "คุณแน่ใจหรือไม่ว่าต้องการลบ Passkey?",
          "registeredPasskeys": "Passkey ที่คุณลงทะเบียนไว้:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "คุณแน่ใจหรือไม่ว่าต้องการลบอุปกรณ์ยืนยันตัวตน?",
        "secMFA": "การยืนยันตัวตนแบบสองปัจจัย",
        "secPwdChange": "เปลี่ยนรหัสผ่าน",
        "title": "ความปลอดภัย"
      },
      "setPW": {
        "acceptTC": "โปรดยืนยัน {terms} ของเราและอ่าน {privacy} ของเรา",
        "killSSO": "ยกเลิกเซสชันที่ใช้งานอยู่ทั้งหมด",
        "msg": {
          "tokenExpired": "ลิงก์หรือโค้ดรหัสผ่านหมดอายุแล้ว โปรดไปตามลิงก์เพื่อรีเซ็ตรหัสผ่านของคุณ: {link}."
        },
        "privacy": "นโยบายความเป็นส่วนตัวของข้อมูล",
        "terms": "ข้อกำหนดและเงื่อนไข",
        "title": "ป้อนรหัสผ่านใหม่"
      }
    },
    "validations": {
      "hasDigit": "ต้องมีตัวเลข",
      "hasLowercase": "ต้องมีตัวอักษรตัวพิมพ์เล็ก",
      "hasSpecial": "ต้องมีอักขระพิเศษ: {chars}",
      "hasUppercase": "ต้องมีตัวอักษรตัวพิมพ์ใหญ่",
      "invalidCharacters": "มีอักขระที่ไม่ถูกต้อง",
      "maxLength": "อนุญาตสูงสุด {max} อักขระ",
      "minLength": "ต้องมีอย่างน้อย {min} อักขระ",
      "notSameAsEmail": "คล้ายกับที่อยู่อีเมลมากเกินไป",
      "onlyValidCharactersAllowed": "อนุญาตเฉพาะตัวอักษร ตัวเลข และเว้นวรรคเท่านั้น",
      "required": "จำเป็นต้องระบุ",
      "sameAsPassword": "รหัสผ่านไม่ตรงกัน",
      "tcAccepted": "โปรดยืนยันข้อกำหนดและเงื่อนไขของเรา",
      "validEmail": "ที่อยู่อีเมลไม่ถูกต้อง",
      "validOTP": "โปรดป้อนรหัสยืนยัน"
    }
  }
}
